module.exports = __webpack_public_path__ + "img/medical_physical_04.dc0849ff.jpg";